export default "__VITE_ASSET__uyjxDRYm__"